<!--
/**
* @name: CategoryList.vue
* @description: 分类管理
* @author: 于海威
* @create: 2020/08/24 17:31:50
* @update: 2020/08/24 17:31:50
*/
-->

<template>
  <y-view :loading="isLoading">
    <div slot="left" class="left-panel">
      <k-tree :data.sync="treeDataList" hasActions class="mt-1" selectedRule="some" keyField="id" childField="children" v-model="menuId" @toggle="onToggle">
        <div slot-scope="{ item }" :class="css.tree_item">
          <div>{{ item.name }}</div>
          <div v-if="item.name == '商品类别'" :class="css.item_action"><a href="javascript:void(0);" @click="onAddCat">新增</a></div>
        </div>
      </k-tree>
    </div>
    <div class="right-content">
      <y-query :hasSearchButton="false" spaceBetween>
        <y-query-item>
          <k-input placeholder="请输入商品分类名称" clearable v-model="catName"></k-input>
        </y-query-item>
        <y-query-item>
          <k-button type="primary" @click="onSearch">查询</k-button>
        </y-query-item>
        <y-query-item>
          <k-button @click="onReset">重置</k-button>
        </y-query-item>
      </y-query>
      <k-table :data="jurisdictionList" hasIndex :height="$root.tableHeightX" :rightFixedNumber="1" class="mt-1" :columns="initColumns()"></k-table>
    </div>
    <k-popup :show.sync="isShowAddCat" :title="popupTitle" :layer="popupLayer" @after-ok="onSave">
      <y-popup-body size="big">
        <y-form titleWidth="90px" titleAlign="right" contentWidth="400px">
          <y-form-item title="分类ID：">
            <k-input placeholder="按照编码规则自动生成" block disabled v-model="editPara.id"></k-input>
          </y-form-item>
          <y-form-item title="分类名称：" required>
            <k-input placeholder="分类名称最多输入10个字符" block v-model="editPara.name" v-validate="'required'"></k-input>
          </y-form-item>
          <y-form-item title="上级分类：" required>
            <k-select-tree
              v-validate="'required'"
              v-model="editPara.pid"
              layerMinWidthEqual
              keyField="id"
              childField="children"
              textField="name"
              :text="editPara.pname"
              :data.sync="treeDataList"
              clearable
              block
            ></k-select-tree>
          </y-form-item>
          <y-form-item title="分类图片:" align="top">
            <div class="row">
              <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploaded"></y-upload-file>
              <y-image @delete="onDelete" v-dragging="{ list: pictureList, item: img, group: 'image' }" v-for="(img, index) in pictureList" :key="index" :index="index" :src="img"></y-image>
            </div>
            <div class="mt-1">（只能上传1张，每张大小不超过 3M，建议尺寸80*80 px）</div>
          </y-form-item>
          <y-form-item title="推荐品牌：">
            <k-select2
              v-model="editPara.goodsBrandCodeList"
              :data="brandList"
              text-field="gbname"
              key-field="gbcode"
              search-field="gbname"
              style="width: 400px;"
              layer-width="auto"
              layerMinWidthEqual
              :nearby="true"
              placeholder="请选择商品品牌"
              ref="selectBrand"
            >
            </k-select2>
          </y-form-item>
          <y-form-item title="关联属性：" v-if="isShowAttr">
            <k-select2
              v-model="editPara.goodsAttributeIdList"
              :data="attrList"
              text-field="name"
              key-field="id"
              search-field="name"
              style="width: 400px;"
              layer-width="auto"
              layerMinWidthEqual
              :nearby="true"
              placeholder="请选择关联属性"
              ref="selectAttribte"
            >
            </k-select2>
          </y-form-item>
          <y-form-item title="状态：" required>
            <div>
              <k-radio :value="true" v-model="editPara.isEnabled">启用</k-radio>
              <k-radio :value="false" v-model="editPara.isEnabled">停用</k-radio>
            </div>
          </y-form-item>
        </y-form>
      </y-popup-body>
    </k-popup>
  </y-view>
</template>

<script>
import {
  NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_LIST_TREE,
  NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_LIST,
  NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_BRAND_LIST,
  NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_SAVE,
  NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_UPDATE,
  NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_ENABLED,
  NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_DISABLED,
  NESTLE_GOODS_BACK_SERVER_GOODS_ATTRIBUTE_LIST,
  NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
} from "@/assets/modules/apiList";

const initPara = () => ({
  id: "",
  name: "",
  pid: 0,
  pname: "",
  isEnabled: null,
  picture: "",
  goodsBrandCodeList: [],
  goodsAttributeIdList: [],
});
export default {
  data() {
    return {
      menuId: "",
      isLoading: false,
      treeDataList: [],
      uploadUrl: NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
      jurisdictionList: [],
      brandList: [],
      attrList: [],
      isShowAddCat: false,
      isView: false,
      isEdit: false,
      editPara: initPara(),
      isSaving: false,
      catName: "",
      pictureList: [],
    };
  },
  watch: {
    isShowAddCat(v) {
      if (!v) {
        this.editPara = initPara();
        if (this.isView) {
          this.isView = false;
        }
        if (this.isEdit) {
          this.isEdit = false;
        }
      }
    },
  },
  computed: {
    popupTitle() {
      if (this.isView) {
        return "查看分类";
      } else if (this.isEdit) {
        return "编辑分类";
      } else {
        return "新增分类";
      }
    },
    popupLayer() {
      if (this.isView) {
        return "header, body, close, mask";
      } else {
        return "header, body, footer, close, mask";
      }
    },
  },
  methods: {
    onUploaded(data) {
      this.pictureList = [];
      this.pictureList.push(data.data[0].url);
    },
    getBrandList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_BRAND_LIST,
        para: {},
      }).then((res) => {
        this.brandList = res;
      });
    },
    onToggle() {
      this.getCatList(this.menuId);
    },
    initColumns() {
      return [
        {
          name: "分类名称",
          field: "name",
          style: {
            width: 150,
            textAlign: "center",
          },
        },
        {
          name: "分类图片",
          field: "",
          style: {
            width: 150,
            textAlign: "center",
          },
          customRender: (row) => {
            if (row.picture) {
              return (
                <div class={this.css.box}>
                  <img class={this.css.img} src={row.picture} />
                </div>
              );
            } else {
              return <div class={this.css.box}></div>;
            }
          },
        },
        {
          name: "关联属性",
          field: "goodsTypeAttrNames",
          style: {
            width: 150,
            textAlign: "center",
          },
        },
        {
          name: "启用状态",
          field: "",
          style: {
            textAlign: "center",
          },
          customRender: (row) => (
            <k-switch
              checked={row.isEnabled}
              readonly
              onClick={() => {
                this.onChangeStatus(row);
              }}
            />
          ),
        },
        {
          name: "操作",
          style: {
            textAlign: "center",
          },
          customRender: (row) => {
            const addButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onAdd(row);
                }}
              >
                新增
              </a>
            );
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEdit(row);
                }}
              >
                编辑
              </a>
            );
            if (row.id === 0) {
              return <div>{addButton}</div>;
            }
            return (
              <div>
                {addButton}&#12288;{editButton}
              </div>
            );
          },
        },
      ];
    },
    onSave() {
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      const { tip } = this.$root;
      if (para.name.replace(/\s*/, "").length < 1) {
        return tip("请输入分类名称");
      }
      if (para.id != 0 && !para.pid && para.pid != "0") {
        return tip("请选择父级分类");
      }
      para.picture = this.pictureList && this.pictureList.length > 0 ? this.pictureList[0] : "";
      this.isSaving = true;
      this.isLoading = true;
      let api = NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_SAVE;
      if (this.isEdit) {
        api = NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_UPDATE;
      }
      this.$fetch({
        api,
        para,
      })
        .then(() => {
          this.isSaving = false;
          this.isLoading = false;
          this.isShowAddCat = false;
          this.getGoodsCatList();
          this.getCatList(this.menuId);
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
    getGoodsCatList() {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_LIST_TREE,
        para: {},
      })
        .then((res) => {
          this.treeDataList = [
            {
              id: 0,
              name: "商品类别",
              pid: "",
              pname: "",
              children: res,
              __open__: true,
            },
          ];
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getCatList(pid) {
      this.isLoading = true;
      let rank = pid == "0" || !pid ? "1" : "";
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_LIST,
        para: { pid: pid ? pid : 0, name: this.catName, rank: rank },
      })
        .then((res) => {
          if (res && res.length > 0) {
            for (let i = 0; i < res.length; i++) {
              let goodsTypeAttrIds = [];
              let goodsTypeAttrNames = [];
              let goodsBrandCodes = [];
              let goodsBrandNames = [];
              for (let j = 0; j < res[i].goodsTypeAttributeVOList.length; j++) {
                goodsTypeAttrIds.push(res[i].goodsTypeAttributeVOList[j].attributeId);
                goodsTypeAttrNames.push(res[i].goodsTypeAttributeVOList[j].attributeName);
                res[i].goodsTypeAttrIds = goodsTypeAttrIds.join(",");
                res[i].goodsTypeAttrNames = goodsTypeAttrNames.join(",");
              }
              if (res[i].goodsTypeBrandVOList && res[i].goodsTypeBrandVOList.length > 0) {
                for (let k = 0; k < res[i].goodsTypeBrandVOList.length; k++) {
                  goodsBrandCodes.push(res[i].goodsTypeBrandVOList[k].goodsBrandCode);
                  goodsBrandNames.push(res[i].goodsTypeBrandVOList[k].goodsBrandName);
                  res[i].goodsBrandCodes = goodsBrandCodes.join(",");
                  res[i].goodsBrandNames = goodsBrandNames.join(",");
                }
              }
            }
          }
          this.jurisdictionList = res;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getAttrList() {
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_ATTRIBUTE_LIST,
        para: {},
      })
        .then((res) => {
          this.attrList = res;
        })
        .catch(() => {});
    },
    onSearch() {
      this.getCatList(this.menuId);
    },
    onReset() {
      this.catName = "";
      this.getCatList(this.menuId);
    },
    onAdd(row) {
      this.isShowAttr = true;
      this.getBrandList();
      this.getAttrList();
      let { pid, parentNameUrl } = row;
      if (parentNameUrl.indexOf("-") > -1) {
        parentNameUrl = parentNameUrl.split("-").slice(-2)[0];
      }
      this.editPara.pid = pid;
      this.editPara.pname = pid == 0 ? "商品类别" : parentNameUrl;
      this.isShowAddCat = true;
    },
    onAddCat() {
      this.getBrandList();
      this.isShowAttr = false;
      this.editPara.pname = "商品类别";
      this.isShowAddCat = true;
    },
    onEdit(row) {
      this.isShowAttr = true;
      let editPara = JSON.parse(JSON.stringify(row));
      if (editPara.name.indexOf("-") > -1) {
        editPara.name = editPara.name.split("-").slice(-1)[0];
      }
      let tmp = "";
      const findParentNodeNameById = (id, arr) => {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id == id) {
            tmp = arr[i].name;
            break;
          }
          if (arr[i].children && arr[i].children.length) {
            findParentNodeNameById(id, arr[i].children);
          }
        }
      };
      if (editPara.pid === 0) {
        editPara.pname = "商品类别";
      } else {
        findParentNodeNameById(editPara.pid, this.treeDataList);
        if (tmp) {
          editPara.pname = tmp;
        }
      }
      editPara.goodsBrandCodeList = editPara.goodsBrandCodes ? editPara.goodsBrandCodes.split(",") : [];
      editPara.goodsAttributeIdList = editPara.goodsTypeAttrIds ? editPara.goodsTypeAttrIds.split(",") : [];
      this.pictureList = editPara.picture ? [editPara.picture] : [];
      this.editPara = editPara;
      this.isEdit = true;
      this.isShowAddCat = true;
      this.getBrandList();
      this.getAttrList();
    },
    onChangeStatus(row) {
      let { id, isEnabled } = row;
      this.$dialog({
        title: "提示",
        content: `是否确认${row.isEnabled ? "停用" : "启用"}该商品分类？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: row.isEnabled ? NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_DISABLED : NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_ENABLED,
            para: { id },
          })
            .then(() => {
              this.isLoading = false;
              this.getCatList(this.menuId);
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
  },
  created() {
    this.getGoodsCatList();
    this.getCatList(this.menuId);
  },
};
</script>

<style lang="postcss" module="css">
.search_key {
  width: 160px;
}
.tree_item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  & .item_action {
    display: none;
  }
  &:hover .item_action {
    display: block;
    animation: fade 0.3s linear;
  }
}
@keyframes fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.box {
  padding: 10px 0;
  & > .img {
    width: 70px;
    height: 70px;
  }
}
</style>
